import '../stylesheets/application_about_member_registration';
